import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import type { AnalyticsDailyPoint } from '../../types/dashboard'
import { formatChartDate, tickInterval } from './chartUtils'

const SERIES_COLOR = '#3987e5'
const GRID_COLOR = 'rgba(255,255,255,0.07)'
const AXIS_COLOR = '#8888a0'

interface ReviewVolumeChartProps {
  data: AnalyticsDailyPoint[]
}

export default function ReviewVolumeChart({ data }: ReviewVolumeChartProps) {
  return (
    <div className="bg-rd-surface border border-white/[0.07] rounded-xl p-4">
      <p className="text-xs text-rd-muted mb-3">Review volume</p>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
          <CartesianGrid stroke={GRID_COLOR} vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={formatChartDate}
            interval={tickInterval(data.length)}
            tick={{ fill: AXIS_COLOR, fontSize: 11 }}
            axisLine={{ stroke: GRID_COLOR }}
            tickLine={false}
          />
          <YAxis allowDecimals={false} tick={{ fill: AXIS_COLOR, fontSize: 11 }} axisLine={false} tickLine={false} width={28} />
          <Tooltip
            contentStyle={{ background: '#1a1a26', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, fontSize: 12 }}
            labelStyle={{ color: '#f0f0f5' }}
            itemStyle={{ color: '#f0f0f5' }}
            cursor={{ fill: 'rgba(255,255,255,0.04)' }}
          />
          <Bar dataKey="review_count" name="Reviews" fill={SERIES_COLOR} radius={[4, 4, 0, 0]} maxBarSize={28} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
